<template>
  <i-modal 
    v-model="modal.modal" 
    title="検索条件を保存" 
    width="600" 
    class="modal-search-save" 
    @on-visible-change="onVisibleChange"
  >
    <div class="contents">
      <div class="text">
        現在の検索条件を保存します。
      </div>
      <div class="form_item">
        <span class="label">保存名</span>
        <i-input v-model="name" style="width: 320px;" />
      </div>
    </div>
    <div slot="footer">
      <i-button type="default" @click="onClickCancel">キャンセル</i-button>
      <i-button type="primary" @click="onClickSave">保存</i-button>
    </div>
  </i-modal>
</template>

<script>
// import _ from 'lodash'
import { Modal, Input, Button } from 'view-design'
import SearchConditionRepository from '@/repositories/searchConditionRepository.js'

export default {
  components: {
    'i-modal': Modal,
    'i-input': Input,
    'i-button': Button,
  },
  data() {
    return {
      modalLoading: false,
      name: '',
    }
  },
  props: {
    type: {
      type: String,
      default: '',
      required: true,
      validator: function(value) {
        return ['investment', 'residence'].indexOf(value) !== -1
      },
    },
  },
  computed: {
    modal: {
      get() {
        return this.$store.getters['ModalSearchSave/getModal']
      },
      set(val) {
        this.$store.commit('ModalSearchSave/setModal', val)
      },
    },
  },
  methods: {
    // モーダル 表示/非表示時の処理
    onVisibleChange(isOpen) {
      if (isOpen) {
        // this.getSearchList()
      } else {
        setTimeout(this.resetParams, 300)
      }
    },
    async onClickSave() {
      const type = this.type
      const search = this.modal.search
      const tag = this.modal.tag
      const name = this.name
      this.modalLoading = true
      await SearchConditionRepository.post(search, tag, type, name)
        .then(res => {
          if (res.status === 200) {
            alert('検索項目を保存しました。')
            this.modal = false
          } else if (res.status === 400) {
            alert(res.data.body.message)
          } else {
            alert('検索項目の保存に失敗しました。')
          }
        })
        .catch(e => {
          if (e.message) {
            alert(e.message)
          } else {
            console.log(e)
            alert('検索項目の保存に失敗しました。')
          }
        })
        .finally(() => {
          this.modalLoading = false
        })
    },
    // キャンセルボタン クリック処理
    onClickCancel() {
      this.modal = false
    },
    // パラメータを初期化する
    resetParams() {
      const bodyElement = document.getElementById('top')
      bodyElement.style.overflow = 'visible'

      this.modal.search = {}
      this.modal.tag = {}
      this.modal.type = ''
      this.name = ''
    },
  }
}
</script>

<style lang="scss" scoped>
.modal-search-save {
  .contents {
    text-align: center;
    .text {
      margin-bottom: 16px;
      font-size: 14px;
      font-weight: bold;
    }
    .form_item {
      margin-bottom: 16px;
    }
    .label {
      margin-right: 8px;
      font-size: 14px;
      font-weight: bold;
    }
  }
}
</style>